import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    Select,
    Upload,
    Modal,
    Checkbox,
    Row,
    Col
} from "antd";
import Button from "antd-button-color";

import { PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { addStaff, resetpassword, getRegion, getTerritoryID } from "./service";
import { getTerritory, } from "./../service";
import _ from "lodash";

const { Option } = Select;
const { confirm } = Modal;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
        md: { span: 16 },
        lg: { span: 12 },
    },
};

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0
        },
        sm: {
            span: 16,
            offset: 8
        }
    }
};
const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
        onSuccess("ok");
    }, 0);
};
function success() {
    let secondsToGo = 3;
    const onOkModal = () => {
        window.location.reload();
    }
    const modal = Modal.success({
        title: 'แก้ไขข้อมูลพนักงาน เรียบร้อยแล้ว!',
        okText: 'OK',
        onOk: () => {
            onOkModal()
        },
    });
    const timer = setInterval(() => {
        secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
        clearInterval(timer);
        modal.destroy();
        window.location.reload();
    }, secondsToGo * 1000);
}
function error(message) {
    let secondsToGo = 3;
    const onOkModal = () => {
        modal.destroy();
    }
    const modal = Modal.warning({
        title: "Error: " + message,
        okText: 'OK',
        onOk: () => {
            onOkModal()
        },
    });
    const timer = setInterval(() => {
        secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
        clearInterval(timer);
    }, secondsToGo * 1000);
}

function resetPassSuccess() {
    let secondsToGo = 3;
    const onOkModal = () => {
        modal.destroy();
    }
    const modal = Modal.success({
        title: 'รีเซ็ตรหัสผ่าน เรียบร้อยแล้ว!',
        okText: 'OK',
        onOk: () => {
            onOkModal()
        },
    });
    const timer = setInterval(() => {
        secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
        clearInterval(timer);
        modal.destroy();
    }, secondsToGo * 1000);
}
function resetPasserror(message) {
    let secondsToGo = 3;
    const onOkModal = () => {
        modal.destroy();
    }
    const modal = Modal.warning({
        title: "Error: " + message,
        okText: 'OK',
        onOk: () => {
            onOkModal()
        },
    });
    const timer = setInterval(() => {
        secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
        clearInterval(timer);
    }, secondsToGo * 1000);
}

function showConfirm(empCd) {
    confirm({
        title: 'ต้องการรีเซ็ตรหัสผ่านพนักงานท่านนี้ ใช่หรือไม่?',
        icon: <ExclamationCircleOutlined />,
        okText: 'ใช่',
        cancelText: 'ไม่ใช่',
        onOk() {
            let data = {
                "empCd": empCd
            }
            resetpassword(data).then(res => {
                if (res && res.status === 200) {
                    resetPassSuccess()
                } else {
                    resetPasserror(res)
                }
            })
        },
        onCancel() {
        },
    });
}
const Editform = (props) => {
    const [form, setFrom] = Form.useForm();
    const [previewVisible, setPreviewVisible] = useState(false)
    const [previewImage, setPreviewImage] = useState('')
    const [previewTitle, setPreviewTitle] = useState('')
    const [fileList, setFileList] = useState([])

    const [load, setLoad] = useState(true)

    const [empCd, setEmpCd] = useState()
    const [empId, setEmpId] = useState()
    const [firstName, setFirstName] = useState()
    const [lastName, setLastName] = useState()
    const [firstName_th, setFirstName_th] = useState()
    const [lastName_th, setLastName_th] = useState()
    const [phone, setPhone] = useState()
    const [email, setEmail] = useState('')
    const [username, setUsername] = useState()
    const [imageURL, setImageURL] = useState()
    const [dataTerritory, setDataTerritory] = useState([])
    const [saleAreaCd, setSaleAreaCd] = useState('')
    const [saleAreaDesc, setSaleAreaArea] = useState('')
    const [userLevel, setUserLevel] = useState()
    const imgInput = React.createRef();

    const [territory_tID, setTerritory_tID] = useState(props.staffDetail.territory_tID)
    const [region_select, setRegion_select] = useState()
    const [territory_select, setTerritory_select] = useState()

    const [dataRegion, setDataRegion] = useState([])
    const [territory, setTerritory] = useState([])

    function setLoadEffect() {
        setLoad(false)
    }

    useEffect(() => {
        var region_select_s = props.staffDetail.territory_tID
        setUserLevel(props.userLevel)
        var chk_mix = []
        region_select_s.map((data, index) => {
            chk_mix.push(Number(data.substring(0, 3)))
        })
        var groupped = _.groupBy(chk_mix, function (n) { return n });
        var result = _.uniq(_.flatten(_.filter(groupped, function (n) { return n.length > 0 })));
        var rs = []
        if (result.length > 1) {
            rs = 311
        } else {
            rs = result
        }
        setRegion_select(rs)

        let data = {
            state: 'detail',
            empCd: props.staffDetail.empCd
        }
        getStaffDetail();
        function getStaffDetail() {
            addStaff(data).then(res => {
                if (res && res.status === 200) {
                    if (res.data.info.imageURL) {
                        setEmpId(res.data.info.saleID)
                        setEmpCd(res.data.info.empCd)
                        setFirstName(res.data.info.firstName)
                        setLastName(res.data.info.lastName)
                        setFirstName_th(res.data.info.firstName_th)
                        setLastName_th(res.data.info.lastName_th)
                        setPhone(res.data.info.phone)
                        setEmail(res.data.info.email)
                        setUsername(res.data.info.username)
                        setImageURL(res.data.info.imageURL)
                        setFileList([{
                            uid: res.data.info.empCd + 'profile',
                            name: 'temp_profile',
                            status: 'done',
                            url: res.data.info.imageURL,
                        }])
                        setSaleAreaCd(res.data.info.saleAreaCd)
                        setSaleAreaArea(res.data.info.saleAreaDesc)

                    } else {
                        setEmpId(res.data.info.saleID)
                        setEmpCd(res.data.info.empCd)
                        setFirstName(res.data.info.firstName)
                        setLastName(res.data.info.lastName)
                        setFirstName_th(res.data.info.firstName_th)
                        setLastName_th(res.data.info.lastName_th)
                        setPhone(res.data.info.phone)
                        setEmail(res.data.info.email)
                        setUsername(res.data.info.username)
                        setImageURL(res.data.info.imageURL)
                        setSaleAreaCd(res.data.info.saleAreaCd)
                        setSaleAreaArea(res.data.info.saleAreaDesc)
                    }
                    getData();
                }
                // setLoadEffect()
            })
        }
        function getData() {
            getTerritory().then(res => {
                if (res && res.status === 200) {
                    setDataTerritory(res.data)
                    getRegionDetail();
                }
            })
        }
        function getRegionDetail() {
            getDataRegion();
        }
        function getDataRegion() {
            getTerritoryID(rs).then(res => {
                if (res && res.status === 200) {
                    setTerritory(res.data)
                    getRegion().then(res => {
                        if (res && res.status === 200) {
                            setDataRegion(res.data)
                            setLoadEffect()
                        }
                    })
                }
            })
        }
    }, [props]);

    const handleCancel = () => {
        setPreviewVisible(false)
    }
    const handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview)
        setPreviewVisible(true)
        setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1))
    };

    const handleChange = ({ fileList }) => {
        setFileList(fileList)
    }

    const selectArea = (e, name) => {
        setSaleAreaCd(e)
        setSaleAreaArea(name.territoryname)
    }

    const onChange = (checkedValues) => {
        setTerritory_select(checkedValues)
    }
    const optionArea = (
        // const [saleAreaCd, setSaleAreaCd] = useState('')
        // const [saleAreaArea, setSaleAreaArea] = useState('')
        <Select
            showSearch
            style={{ width: '100%' }}
            placeholder="Search to Select"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }
            onChange={selectArea}
        >
            {
                dataTerritory.map((data, index) => {
                    return (
                        <Option key={index} value={data.tID} territoryname={data.territory}>{data.territory}</Option>
                    );
                })
            }
        </Select>
    )
    const resetPass = () => {
        showConfirm(empCd)
    }
    const onFinish = (values) => {
        const formData = new FormData();
        var terri = values.territory
        var terriCd = []
        var terriName = []

        terri.map((data, index) => {
            var t_name = _.find(territory, function (t) { return t.tID == terri[index] })
            terriName.push(t_name.territory)
            terriCd.push(t_name.tID)
        })

        if (fileList.length > 0) {
            if (fileList[0].name.includes('temp_profile')) {
                formData.append('state', 'update');
                formData.append('id', empId);
                formData.append('empCd', values.empCd);
                formData.append('firstName', values.firstName);
                formData.append('lastName', values.lastName);
                formData.append('firstName_th', values.firstName_th,);
                formData.append('lastName_th', values.lastName_th);
                formData.append('phone', values.phone);
                if (values.email == '' || values.email == null) {
                    // formData.append('email', '');
                } else {
                    formData.append('email', values.email);
                }
                terriCd.forEach((item, index) => {
                    formData.append(`saleAreaCd[${index}]`, item);
                });
                terriName.forEach((item, index) => {
                    formData.append(`saleAreaDesc[${index}]`, item);
                });
            } else {
                fileList.forEach((item, index) => {
                    formData.append('image',
                        item.originFileObj
                    );
                });
                formData.append('state', 'update');
                formData.append('id', empId);
                formData.append('empCd', values.empCd);
                formData.append('firstName', values.firstName);
                formData.append('lastName', values.lastName);
                formData.append('firstName_th', values.firstName_th,);
                formData.append('lastName_th', values.lastName_th);
                // formData.append('position', values.position);
                formData.append('phone', values.phone);
                // formData.append('email', values.email);
                if (values.email == '' || values.email == null) {
                    // formData.append('email', '');
                } else {
                    formData.append('email', values.email);
                }
                terriCd.forEach((item, index) => {
                    formData.append(`saleAreaCd[${index}]`, item);
                });
                terriName.forEach((item, index) => {
                    formData.append(`saleAreaDesc[${index}]`, item);
                });
            }

        } else {
            formData.append('state', 'update');
            formData.append('id', empId);
            formData.append('empCd', values.empCd);
            formData.append('firstName', values.firstName);
            formData.append('lastName', values.lastName);
            formData.append('firstName_th', values.firstName_th,);
            formData.append('lastName_th', values.lastName_th);
            formData.append('phone', values.phone);
            if (values.email == '' || values.email == null) {
                // formData.append('email', '');
            } else {
                formData.append('email', values.email);
            }
            terriCd.forEach((item, index) => {
                formData.append(`saleAreaCd[${index}]`, item);
            });
            terriName.forEach((item, index) => {
                formData.append(`saleAreaDesc[${index}]`, item);
            });
        }

        addStaff(formData).then(res => {
            if (res && res.status === 200) {
                form.resetFields();
                setFileList([])
                success()
            } else {
                error(res)
            }
        })
    };

    const prefixSelector = (
        <Form.Item name="prefix" noStyle>
            <Select style={{ width: 70 }}>
                <Option value="+66">+66</Option>
            </Select>
        </Form.Item>
    );

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    );

    const selectRegion = (e, name) => {
        setRegion_select(e)
        function getData() {
            getTerritoryID(e).then(res => {
                if (res && res.status === 200) {
                    setTerritory(res.data)
                }
            })
        }
        getData();
    }

    const optionRegion = () => {
        var u_level = props.userLevel
        var dis = true
        if(u_level == 99){
            dis = false
        }
        return (<Select
            disabled={dis}
            showSearch
            style={{ width: '100%' }}
            placeholder="Search to Select"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }
            onChange={selectRegion}
        >
            {
                dataRegion.map((data, index) => {
                    return (
                        <Option key={index} value={data.rID} regionname={data.region}>{data.region}</Option>
                    );
                })
            }
        </Select>)
    }

    const optionTerritory = (
        // <Checkbox.Group style={{ width: '100%' }} defaultValue={territory_tID} onChange={onChange}>
        <Checkbox.Group style={{ width: '100%' }} onChange={onChange}>
            <Row>
                {territory.map((data, index) => {
                    return (
                        <Col span={12} key={index}>
                            <Checkbox value={data.tID}>{data.territory}</Checkbox>
                        </Col>
                    );
                })}
            </Row>
        </Checkbox.Group>
    )

    const propsUpload = {
        onRemove: file => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            return {
                fileList: newFileList,
            };
        },
        beforeUpload: file => {
            setFileList(fileList, file)
            return false;
        },
    };
    if (load) {
        return (
            <div>
                loading
            </div>
        );
    } else {
        return (
            <div >
                <Form
                    {...formItemLayout}
                    form={form}
                    name="editStaff"
                    id="editStaff"
                    onFinish={onFinish}
                    initialValues={{
                        prefix: "+66",
                        empCd: empCd,
                        firstName: firstName,
                        lastName: lastName,
                        firstName_th: firstName_th,
                        lastName_th: lastName_th,
                        phone: phone,
                        email: email,
                        username: username,
                        imageURL: imageURL,
                        area: saleAreaCd,
                        region: region_select,
                        territory: territory_tID
                    }}
                    scrollToFirstError
                >
                    <Form.Item
                        label="รูปพนักงาน"
                    >
                        <Upload {...propsUpload}
                            listType="picture-card"
                            fileList={fileList}
                            onPreview={handlePreview}
                            onChange={handleChange}
                            customRequest={dummyRequest}
                            rowKey={fileList}
                            style={{ padding: '0px' }}
                            ref={imgInput}
                        >
                            {fileList.length >= 1 ? null : uploadButton}
                        </Upload>
                        <Modal
                            visible={previewVisible}
                            title={previewTitle}
                            footer={null}
                            onCancel={handleCancel}
                        >
                            <img alt="" style={{ width: '100%' }} src={previewImage} />
                        </Modal>
                    </Form.Item>
                    <Form.Item
                        name="empCd"
                        label="รหัสพนักงาน"
                        rules={[
                            {
                                required: true,
                                message: "กรุณาระบุ รหัสพนักงานขาย!",
                            },
                            {
                                pattern: /^(?:\d*)$/,
                                message: "รหัสพนักงานขาย เป็นตัวเลขเท่านั้น!",
                            },
                            {
                                pattern: /^[\d]{0,9}$/,
                                message: "กรุณาระบุ เป็นตัวเลข 9 หลัก",
                            }
                        ]}
                    >
                        {/* <Input disabled={userLevel == 99 ? false:true} /> */}
                        <Input disabled={true} />
                    </Form.Item>
                    <Form.Item
                        name="firstName"
                        label="ชื่อ (EN)"
                        rules={[
                            {
                                required: true,
                                message: "กรุณาระบุ ชื่อภาษาอังกฤษ!",
                            },
                            {
                                pattern: /^[a-zA-Z@~`!@#$%^&*()_=+\\\\';:\"\\/?>.<,-?:\d*]+$/,
                                // pattern: /^[a-zA-Z@~`!@#$%^&*()_=+\\\\';:\"\\/?>.<,-]+$/i,
                                message: "กรุณาระบุ เป็นภาษาอังกฤษ!",
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="lastName"
                        label="นามสกุล (EN)"
                        rules={[
                            {
                                required: true,
                                message: "กรุณาระบุ นามสกุลภาษาอังกฤษ!",
                            },
                            {
                                pattern: /^[a-zA-Z@~`!@#$%^&*()_=+\\\\';:\"\\/?>.<,-?:\d*]+$/,
                                // pattern: /^[a-zA-Z@~`!@#$%^&*()_=+\\\\';:\"\\/?>.<,-]+$/i,
                                message: "กรุณาระบุ เป็นภาษาอังกฤษ!",
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="firstName_th"
                        label="ชื่อ (TH)"
                        rules={[{
                            required: true,
                            message: "กรุณาระบุ ชื่อภาษาไทย!"
                        }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="lastName_th"
                        label="นามสกุล (TH)"
                        rules={[{
                            required: true,
                            message: "กรุณาระบุ นามสกุลภาษาไทย!"
                        }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="phone"
                        label="เบอร์โทรศัพท์"
                        rules={[{
                            required: true,
                            message: "กรุณาระบุ เบอร์โทรศัพท์!"
                        }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="email"
                        label="อีเมล์"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="region"
                        label="พื้นที่รับผิดชอบ"
                        rules={[
                            {
                                required: true,
                                message: "กรุณาเลือก พื้นที่รับผิดชอบ!",
                            }
                        ]}
                    >
                        {optionRegion()}
                    </Form.Item>

                    <Form.Item
                        name="territory"
                        label="เขตการขาย"
                        rules={[
                            {
                                required: true,
                                message: "กรุณาเลือก เขตการขาย!",
                            }
                        ]}
                    >
                        {optionTerritory}
                    </Form.Item>

                    <div style={{ paddingBottom: '10%' }}>
                        <Button type="warning" onClick={resetPass} style={{ float: 'left' }}>
                            รีเซ็ตรหัสผ่าน
                        </Button>
                        <Button type="primary" htmlType="submit" style={{ float: 'right' }}>
                            แก้ไขข้อมูล
                        </Button>
                    </div >
                </Form>
            </div >
        );
    }

};

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export default Editform